// Inizializzazione globale dei componenti A-Frame
// Questo file viene importato una sola volta per evitare registrazioni multiple

import {registerAllComponents} from './aframe-components-registry'
import {getRegisteredComponents} from './aframe-components-registry'

// Flag per tracciare se l'inizializzazione è già stata fatta
let initialized = false

// Funzione per inizializzare i componenti A-Frame in modo lazy
const initializeAframeComponents = () => {
  if (initialized) {
    return
  }
  
  // Verifica che AFRAME sia disponibile prima di registrare i componenti
  if (typeof AFRAME === 'undefined') {
    console.warn('⚠️ AFRAME non ancora disponibile, riprovo tra poco...')
    // Riprova dopo un breve delay
    setTimeout(initializeAframeComponents, 100)
    return
  }
  
  console.log('Inizializzazione componenti A-Frame...')
  try {
    registerAllComponents()
    initialized = true
    console.log('✅ Componenti A-Frame inizializzati')
  } catch (error) {
    console.error('❌ Errore nell\'inizializzazione componenti A-Frame:', error)
  }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAframeComponents)
} else {
  // DOM già pronto, inizializza dopo un breve delay per assicurarsi che AFRAME sia caricato
  setTimeout(initializeAframeComponents, 100)
}

// Esporta una funzione per verificare lo stato dei componenti (utile per debug)
export const checkAframeComponents = () => {
  const registered = getRegisteredComponents()
  console.log('Componenti A-Frame registrati:', registered)
  return registered
}

// Esporta anche la funzione di inizializzazione manuale
export {initializeAframeComponents} 